var map = {
	"./a11y-labels.json": 790,
	"./all-star.json": 791,
	"./alter-ego.json": 792,
	"./art-prize/2019.json": 793,
	"./art-prize/2020.json": 794,
	"./art-prize/global.json": 795,
	"./auth.json": 796,
	"./beginners-series.json": 797,
	"./careers-position.json": 798,
	"./careers.json": 799,
	"./faq.json": 800,
	"./footer.json": 801,
	"./global.json": 802,
	"./handbook.json": 803,
	"./home.json": 804,
	"./insight.json": 805,
	"./ipad-3d.json": 806,
	"./ipad-a11y.json": 807,
	"./ipad-brushes.json": 808,
	"./ipad-color.json": 809,
	"./ipad-superpowers.json": 810,
	"./ipad-video.json": 811,
	"./ipad-whats-new.json": 812,
	"./ipad.json": 813,
	"./meta.json": 814,
	"./navigation.json": 815,
	"./pocket-whats-new.json": 816,
	"./pocket.json": 817,
	"./press.json": 818,
	"./prize.json": 819,
	"./sitemap.json": 820,
	"./support.json": 821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 789;